import { Box, Center, Heading, Icon } from "@chakra-ui/react";
import { TbAlertTriangle } from "react-icons/tb";
import { useRouteError } from "react-router-dom";
import { NotFoundPage } from "./not-found";

export function UnknownError() {
    const error = useRouteError();
    const message = error.message || error.statusText || "Something unexpected happened. Please try again later or contact support if the problem persists."
    return (
        <Box bg="white" boxShadow="xs" borderRadius="md" p="sectionGap" mb="sectionGap">
            <Center mb="4"><Icon as={TbAlertTriangle} boxSize="24" color="red.400" mx="auto" /></Center>
            <Heading as="h1" textAlign="center" size="lg" mb="6">Unexpected error</Heading>
            <Heading as="h2" textAlign="center" size="md">{message}</Heading>
        </Box>
    )
}

export function ErrorPage() {
    const error = useRouteError();
    if (error.status === 404) {
        return <NotFoundPage />
    }
    return (
        <UnknownError />
    )
}
